import zh_cn from './zh_cn';
import en from './en';
import zh_tw from './zh_tw';

export default {
    'zh_cn': zh_cn,
    'en': en,
    'zh_tw': zh_tw
}
